import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import None from "../assets/svg/plans/none.svg"
import Plan1 from "../assets/svg/v2/plans/1.svg"
import Plan2 from "../assets/svg/v2/plans/2.svg"
import Plan3 from "../assets/svg/v2/plans/3.svg"
import Plan4 from "../assets/svg/v2/plans/4.svg"
import Plan5 from "../assets/svg/v2/plans/5.svg"
import Plan6 from "../assets/svg/v2/plans/6.svg"
import Plan7 from "../assets/svg/v2/plans/7.svg"
import Plan8 from "../assets/svg/v2/plans/8.svg"



const PackageCard = ({ userData, goToWithdrawal }) => {
    const { t } = useTranslation();
    const [currentLevel, setCurrentLevel] = useState({});

    const levels = [
        {
            image: None,
            plan: 0,
            name: "",
        },
        {
            image: Plan1,
            plan: 1,
            name: "HBAR",
        },
        {
            image: Plan2,
            plan: 2,
            name: "SUI",
        }, {
            image: Plan3,
            plan: 3,
            name: "TRX",
        }, {
            image: Plan4,
            plan: 4,
            name: "DOGE",
        }, {
            image: Plan5,
            plan: 5,
            name: "SOL",
        }, {
            image: Plan6,
            plan: 6,
            name: "BNB",
        }, {
            image: Plan7,
            plan: 7,
            name: "ETH",
        }, {
            image: Plan8,
            plan: 8,
            name: "BTC",
        }
    ];

    useEffect(() => {
        const userVolume = userData?.package;
        setCurrentLevel(levels[userVolume]);
    }, [userData]);



    const oraculo = (props) => {
        if (window.localStorage.getItem("tron")) {
            let value = props / window.localStorage.getItem("tron");
            let fomart = Number.parseFloat(value).toFixed(3);
            let valueFormat = formatNumber(fomart);
            return valueFormat;
        }
    };

    const formatNumber = (value) => {
        if (value >= 1000000) {
            return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (value >= 1000) {
            return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return value.toString();
    }

    return (
        <>

            {userData?.package > 0 ? (
                <>
                    <img src={currentLevel?.image} alt={currentLevel?.name} className="absolute w-12 h-12 right-2 opacity-80 group-hover:opacity-100 top-1" />
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE6")}: {currentLevel?.name}</h1>
                    {parseInt(userData?.balance_available) >= 5 && (
                        <button className="glowing-border text-md w-auto border-2 p-1 cursor-pointer rounded-lg px-2 hover:bg-black/50" onClick={() => goToWithdrawal('balance_available')}>{t("_WITHDRAWINVESTMENT._BUTTON")} </button>
                    )}
                    <div className="group gap-2 flex flex-col ">
                        <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{formatNumber(userData?.balance_available || 0)}</p>
                            <p className="w-2/5">USD</p>
                        </div>
                        <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> {formatNumber(userData?.total_available || 0)}</p>
                            <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                        </div>
                        <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.balance_available)}</p>
                            <p className="w-2/5">SOL</p>
                        </div>
                        <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">{oraculo(userData?.total_available)} </p>
                            <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                        </div>
                    </div>
                </>
            ) :
                <>
                    <h1 className="text-sm">{t("_DASHBOARD._TITLE6")}: {t("_GLOBALV._NONE")}</h1>
                    <div className="group gap-2 flex flex-col ">
                        <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row gap-2 text-white w-full flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">0</p>
                            <p className="w-2/5">USD</p>
                        </div>
                        <div className="flex group-hover:hidden transition-opacity duration-300 opacity-100 group-hover:opacity-0  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end"> 0</p>
                            <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                        </div>
                        <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">0</p>
                            <p className="w-2/5">SOL</p>
                        </div>
                        <div className="hidden group-hover:flex transition-opacity duration-300 opacity-0 group-hover:opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                            <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-3/5 text-end">0</p>
                            <p className="w-2/5">{t("_DASHBOARD._TOTAL")}</p>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

export default PackageCard;
